<template>
    <div class="mb-5 mt-4">

        <v-expansion-panels v-model="panel">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <span v-if="panel != 0"> <strong>Male & Female (Last 15 days) </strong> </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <ApexChart height="400" type="line" :options="chartOptions" ty :series="series">
                    </ApexChart>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

    </div>
</template>
<script>
import ApexChart from "vue-apexcharts";
export default {
    components: {
        ApexChart,
    },
    name: "Bar",

    data() {
        return {
            series: [],
            chartOptions: null,
            panel: 0

        };
    },

    created() {
        this.getChartData();
    },

    watch: {

    },

    methods: {
        getChartData() {
            this.$apollo
                .query({
                    query: require("@/customer/api/getGenderwiseTrend.graphql"),

                })
                .then(data => {
                    let response = data.data.getGenderwiseTrend;
                    let maleArray = new Array()
                    let femaleArray = new Array()
                    let graphLabels = new Array();
                    response.forEach(element => {
                        maleArray.push(element.maleCount)
                        femaleArray.push(element.femaleCount)
                        graphLabels.push(element.date)
                    });

                    this.series = [
                        {
                            name: "Male",
                            data: maleArray
                        },
                        {
                            name: "Female",
                            data: femaleArray
                        }
                    ]

                    this.chartOptions = {
                        chart: {
                            height: 200,
                            type: 'line',
                            dropShadow: {
                                enabled: true,
                                color: '#000',
                                top: 18,
                                left: 7,
                                blur: 10,
                                opacity: 0.2
                            },
                            toolbar: {
                                show: false
                            }
                        },
                        xaxis: {
                            categories: graphLabels,
                            title: {
                                text: 'Date'
                            }
                        },
                        yaxis: {
                            title: {
                                text: 'Count'
                            },
                            min: 0,
                            max: 50
                        },
                        colors: ['#77B6EA', '#545454'],
                        dataLabels: {
                            enabled: true,
                        },

                        title: {
                            text: 'Male & Female (Last 15 days)',
                            align: 'left'
                        },
                        grid: {
                            borderColor: '#e7e7e7',
                            row: {
                                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                opacity: 0.5
                            },
                        },

                    };
                });
        },
    },
};
</script>
  